module.exports = __webpack_public_path__ + "img/sc-bg.38e07a45.png";